import type { EssayCalculatorType } from "@/api/db/schema/essay";
import {
  Activity,
  Calculator,
  Droplets,
  Dumbbell,
  type LucideIcon,
  Ruler,
  TrendingUp,
} from "lucide-react";

export interface CalculatorCatalogItem {
  id: EssayCalculatorType;
  ctaEnabled: boolean;
  title: string;
  categoryTag: string;
  description: string;
  href:
    | "/essay/ipf-gl-calculator"
    | "/essay/1rm-calculator"
    | "/essay/wilks-calculator"
    | "/essay/ffmi-calculator"
    | "/essay/calori-calculator"
    | "/essay/water-calculator"
    | "/essay/body-fat-calculator";
  defaultCtaLabel: string;
  icon: LucideIcon;
}

export const calculatorCatalog: readonly CalculatorCatalogItem[] = [
  {
    id: "ipf_gl",
    ctaEnabled: true,
    title: "IPF GL Points",
    categoryTag: "Powerlifting Katsayısı",
    description:
      "Classic ve Equipped powerlifting performansınızı resmi IPF GL katsayılarıyla karşılaştırın.",
    href: "/essay/ipf-gl-calculator",
    defaultCtaLabel: "IPF GL Puanını Hesapla",
    icon: TrendingUp,
  },
  {
    id: "one_rm",
    ctaEnabled: true,
    title: "1RM Hesaplayıcı",
    categoryTag: "Powerlifting & Güç",
    description:
      "Tek tekrar maksimum gücünüzü hesaplayıp antrenman ağırlıklarınızı planlayın.",
    href: "/essay/1rm-calculator",
    defaultCtaLabel: "1RM Değerini Hesapla",
    icon: Dumbbell,
  },
  {
    id: "wilks",
    ctaEnabled: true,
    title: "Wilks Skoru",
    categoryTag: "Powerlifting Katsayısı",
    description:
      "Vücut ağırlığınızdan bağımsız powerlifting performansınızı karşılaştırın.",
    href: "/essay/wilks-calculator",
    defaultCtaLabel: "Wilks Skorunu Hesapla",
    icon: TrendingUp,
  },
  {
    id: "ffmi",
    ctaEnabled: true,
    title: "FFMI Hesaplayıcı",
    categoryTag: "Yağsız Kas Kütlesi",
    description:
      "Yağsız kütle indeksinizi ve kas kütlesi gelişiminizi değerlendirin.",
    href: "/essay/ffmi-calculator",
    defaultCtaLabel: "FFMI Değerini Hesapla",
    icon: Activity,
  },
  {
    id: "calorie",
    ctaEnabled: true,
    title: "Kalori & TDEE",
    categoryTag: "Günlük Makro & Kalori",
    description:
      "Hedefinize uygun günlük kalori ve makro besin ihtiyacınızı planlayın.",
    href: "/essay/calori-calculator",
    defaultCtaLabel: "Kalori İhtiyacını Hesapla",
    icon: Calculator,
  },
  {
    id: "water",
    ctaEnabled: true,
    title: "Su İhtiyacı",
    categoryTag: "Hidrasyon Rehberi",
    description:
      "Antrenman yoğunluğunuza göre ideal günlük su tüketiminizi belirleyin.",
    href: "/essay/water-calculator",
    defaultCtaLabel: "Su İhtiyacını Hesapla",
    icon: Droplets,
  },
  {
    id: "body_fat",
    ctaEnabled: true,
    title: "Body Fat (Yağ Oranı)",
    categoryTag: "Vücut Kompozisyonu",
    description:
      "Vücut ölçülerinizi kullanarak yağ oranınızı ve vücut kompozisyonunuzu analiz edin.",
    href: "/essay/body-fat-calculator",
    defaultCtaLabel: "Yağ Oranını Hesapla",
    icon: Ruler,
  },
] as const;

export type CtaCalculatorCatalogItem = CalculatorCatalogItem & {
  id: EssayCalculatorType;
  ctaEnabled: true;
};

export const ctaCalculatorCatalog = calculatorCatalog.filter(
  (calculator): calculator is CtaCalculatorCatalogItem => calculator.ctaEnabled,
);

export function getCalculatorCatalogItem(id?: EssayCalculatorType | null) {
  if (!id) return undefined;
  return ctaCalculatorCatalog.find((calculator) => calculator.id === id);
}
